import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bs_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((r) => r, (err) => {
  const url = err.config?.url || "";
  if (err.response?.status === 401 && localStorage.getItem("bs_admin_token") && !url.includes("/auth/")) {
    localStorage.removeItem("bs_admin_token");
    window.location.href = "/admin/login";
  }
  return Promise.reject(err);
});
